export const QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID =
  "QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID";
export const QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL =
  "QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL";
export const QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE =
  "QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE";

export const QUERY_PAYEE_ENGAGEMENTS_LIST = "QUERY_PAYEE_ENGAGEMENTS_LIST";
